import { FC, MouseEventHandler } from 'react';

import { IconEdit } from '@purpur/library/icon/edit';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { ORDER_CART_ENTRY_ID, ORDER_CART_TEST_ID } from '../constants';
import { Price } from '../model';
import {
    CellDetail,
    CellPrice,
    CellPriceText,
    CellTitle,
    NetflixIcon,
    VasEntryListItem,
    VasSwitch,
} from './entries.styles';

type NetflixVasProps = {
    isPremium: boolean;
    premiumPrice: Price;
    showDescription?: boolean;
    onChange?: MouseEventHandler<HTMLButtonElement>;
    isLoading?: boolean;
};

export const NetflixVas: FC<NetflixVasProps> = ({
    isPremium,
    premiumPrice,
    showDescription = true,
    onChange,
    isLoading,
}) => {
    const { t } = useTranslations();
    const title = isPremium
        ? t['order_cart.entry_netflix.title.premium']
        : t['order_cart.entry_netflix.title.standard'];
    const description = isPremium
        ? t['order_cart.entry_netflix.description.premium']
        : t['order_cart.entry_netflix.description.standard'];
    const switchText = isPremium
        ? t['order_cart.entry_netflix.change_to_standard']
        : t['order_cart.entry_netflix.change_to_premium'];

    return (
        <VasEntryListItem data-test={ORDER_CART_ENTRY_ID.NETFLIX_VAS} aria-label={title}>
            <NetflixIcon />
            <CellTitle data-test={ORDER_CART_TEST_ID.ENTRY_TITLE_NETFLIX}>{title}</CellTitle>
            <CellDetail>{showDescription ? description : null}</CellDetail>
            {isPremium ? (
                <CellPrice price={premiumPrice} isMonthly={true} dataTest={ORDER_CART_TEST_ID.NETFLIX_VAS_PRICE} />
            ) : (
                <CellPriceText data-test={ORDER_CART_TEST_ID.NETFLIX_VAS_PRICE}>
                    {t['order_cart.entry_netflix.price.standard_v2']}
                </CellPriceText>
            )}
            {!!onChange && (
                <VasSwitch
                    onClick={onChange}
                    loading={isLoading}
                    variant="text"
                    size="lg"
                    data-test={ORDER_CART_TEST_ID.ENTRY_ACTION}
                >
                    <IconEdit size="xs" />
                    {switchText}
                </VasSwitch>
            )}
        </VasEntryListItem>
    );
};
